<template>
  <div>
    <template v-if="tokenInfo">
      <existing-client v-if="tokenInfo.existingClient" :key="token" :token="token" :token-info="tokenInfo" />
      <member-information v-else :key="token" :signup-token="token" :token-info="tokenInfo" />
    </template>
    <div v-else-if="failed" class="form-container pa-6">
      <p>メールに記載されたURLをご確認の上、再度お手続きください。</p>
      <v-btn :to="registrationRoute" color="primary" rounded block>メールアドレスの登録へ戻る</v-btn>
    </div>
  </div>
</template>

<script>
import { getVsSignupExceptionKey, vsSignupRoute } from '@/utils/vs-signup-policy'
import { sessionStorageMixin } from '@/mixins/session-storage.mixin'
import commonConstants from './common.constants'
import MemberInformation from './MemberInformation'
import ExistingClient from './ExistingClient'

export default {
  components: { MemberInformation, ExistingClient },
  mixins: [sessionStorageMixin],
  data () {
    return { token: null, tokenInfo: null, failed: false, requestId: 0 }
  },
  computed: {
    registrationRoute () {
      return vsSignupRoute(this.$route, 'register')
    }
  },
  watch: {
    '$route.fullPath': 'loadToken'
  },
  mounted () {
    this.loadToken()
  },
  beforeDestroy () {
    this.requestId++
  },
  methods: {
    async loadToken () {
      const requestId = ++this.requestId
      const token = this.$route.fullPath.split('?')[1]
      const exceptionKey = getVsSignupExceptionKey(this.$route)
      this.tokenInfo = null
      this.failed = false
      if (!token) {
        this.failed = true
        return
      }
      try {
        await this.$doLoading(async () => {
          await this.$showGqlError(async () => {
            const { data } = await this.$store.dispatch('signupTokenInfo', {
              apollo: this.$apollo, token, exceptionKey
            })
            if (requestId !== this.requestId) return
            const tokenInfo = data.vsSignupTokenInfo
            // Existing-account signup is available only through a validated special URL.
            if (tokenInfo.existingClient && !exceptionKey) {
              await this.$router.replace({ name: 'signup-not-found' })
              return
            }
            const saved = this.getFromStorage(commonConstants.storageKey)
            if (tokenInfo.existingClient || saved?.token !== token) {
              this.removeFromStorage(commonConstants.storageKey)
            }
            this.token = token
            this.tokenInfo = tokenInfo
          })
        })
      } catch (_) {
        if (requestId === this.requestId) this.failed = true
      }
    }
  }
}
</script>
